import {gql} from '@apollo/client';

const PricingGroup = gql`
    fragment PricingGroup on PricingGroup {
        pricingGroupId
        title
        deleted
    }
`;

export const GetPricingGroups = gql`
    query GetPricingGroups(
        $institutionSetIds: [InstitutionSetId!]
        $pricingGroupIds: [PricingGroupId!]
        $includeDeleted: Boolean
    ) {
        finance {
            pricingGroups {
                list(
                    institutionSetIds: $institutionSetIds
                    pricingGroupIds: $pricingGroupIds
                    includeDeleted: $includeDeleted
                ) {
                    ...PricingGroup
                }
            }
        }
    }

    ${PricingGroup}
`;

export const GetNewAndOldPricingGroups = gql`
    query GetNewAndOldPricingGroups($institutionSetId: InstitutionSetId!, $pricingGroupIds: [PricingGroupId!]) {
        finance {
            pricingGroups {
                behaviors(institutionSetId: $institutionSetId) {
                    behaviorId
                }
                list(institutionSetIds: [$institutionSetId]) {
                    ...PricingGroup
                }
            }
            oldPricingGroups: pricingGroups {
                list(pricingGroupIds: $pricingGroupIds) {
                    ...PricingGroup
                }
            }
        }
    }

    ${PricingGroup}
`;

export const GetPricingGroupsWithBehaviors = gql`
    query GetPricingGroupsWithBehaviors($institutionSetId: InstitutionSetId!) {
        finance {
            pricingGroups {
                behaviors(institutionSetId: $institutionSetId) {
                    behaviorId
                }
                list(institutionSetIds: [$institutionSetId]) {
                    ...PricingGroup
                }
            }
        }
    }

    ${PricingGroup}
`;

export const UpdatePricingGroups = gql`
    mutation UpdatePricingGroups($institutionSetId: InstitutionSetId!, $pricingGroups: [PricingGroupInput!]!) {
        finance {
            pricingGroups {
                setPricingGroups(institutionSetId: $institutionSetId, pricingGroups: $pricingGroups) {
                    ...PricingGroup
                }
            }
        }
    }

    ${PricingGroup}
`;
